module.exports = __webpack_public_path__ + "static/kellermannova-9ef604a7c33988cdd66dcc0259367575.jpg";